import React from 'react';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

const SelectList = ({ label, name, value, onChange, options, defaultValue, className, ...props }) => {
  return (
    <TextField
      select
      label={label}
      name={name}
      value={value}
      onChange={onChange}
      variant="outlined"
      fullWidth
      className={className}
      defaultValue={defaultValue}
      SelectProps={{
        IconComponent: props.customicon,
        MenuProps: {
          disableScrollLock: true,
        },
        renderValue: (selectedValue) => options.filter(item => item.value === selectedValue)[0]?.label
      }}
      {...props}
    >
      {options.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.fullText ? option.fullText : option.label}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default SelectList;
